import React, { useEffect, useRef, useState } from 'react'
import useEffectOnce from '../hooks/useEffectOnce';
import { useDispatch, useSelector } from 'react-redux';
import { InputText } from 'primereact/inputtext';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Admin_API } from '../ApiNames';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import { Panel } from 'primereact/panel';
import { useLocation, useParams } from 'react-router-dom';
import { Dialog } from 'primereact/dialog';
import { Stepper } from 'primereact/stepper';
import { StepperPanel } from 'primereact/stepperpanel';
export const AdminViewSupervisorreport = () => {
    const location = useLocation();
    const [globalFilter, setGlobalFilter] = useState('');
    const stepperRef = useRef(null);
    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("SupervisorID") as any);
    }, [location]);
    const { SupervisorID } = useParams();
    const [casesdata, setCasesData] = useState<[]>([]);
    const getdata = async () => {
        try {
            const payload = { q: 2, asid: SupervisorID };
            const apiname = Admin_API.super_API;
            const data = await LoginService.getData(apiname, payload);
            setCasesData(data);
        } catch (error) {

        }
    };
    const [supervisor, setSupervisor] = useState<[]>([]);

    const supervisordata = async () => {
        try {
            const payload = { q: 3, asid: SupervisorID };
            const apiname = Admin_API.super_API;
            const data1 = await LoginService.getData(apiname, payload);
            setSupervisor(data1);
        } catch (error) {

        }
    };
    const [datadoctor, setDatadoctor] = useState<[]>([]);
    const doctordata = async () => {
        try {
            const payload = { q: 4, asid: SupervisorID };
            const apiname = Admin_API.super_API;
            const data2 = await LoginService.getData(apiname, payload);
            setDatadoctor(data2);
        } catch (error) {

        }
    };
    const [assistant, setAssistant] = useState<[]>([]);

    const assisantdata = async () => {
        try {
            const payload = { q: 5, asid: SupervisorID };
            const apiname = Admin_API.super_API;
            const data3 = await LoginService.getData(apiname, payload);
            setAssistant(data3);
        } catch (error) {

        }
    };
    const [linkassistant, setlinkassistant] = useState<[]>([]);

    const linkassisantdata = async () => {
        try {
            const payload = { q: 6, asid: SupervisorID };
            const apiname = Admin_API.super_API;
            const data4 = await LoginService.getData(apiname, payload);
            setlinkassistant(data4);
        } catch (error) {

        }
    };

    useEffectOnce(() => {
        getdata()
        supervisordata()
        doctordata()
        assisantdata()
        linkassisantdata()

    }, []);
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/viewadminsreports.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container">
            <div className="main-content">
                <div className="content-wrapper">
                    <div className="grid">
                        <div className="col-9">
                            <h2>Supervisor Profile</h2>
                        </div>
                        <div className="col-3">
                            <a
                                title="help"
                                onClick={(e) => openWindow(e, IUrl)}
                                style={{

                                    color: "blue",
                                    fontSize: 15, cursor: "pointer"
                                }}
                            >Help for this Page &nbsp;
                                <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                            </a>
                        </div>
                    </div>
                    <section className="content">
                        <div className="grid">
                            <div className="col-3">
                                {casesdata.map((response: any) => (
                                    <>
                                        <Card>
                                            <div style={{
                                                height: '150px',
                                                backgroundColor: 'rgb(23, 162, 184)',
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center', // Center horizontally
                                                flexDirection: 'column', // Stack the headings vertically
                                                width: '100%'
                                            }}>
                                                {/* <br></br> */}
                                                <h3 style={{ margin: '0', color: 'white' }}>Supervisor</h3>

                                                <img
                                                    src={response.photo}
                                                    alt="User Avatar"
                                                    style={{
                                                        width: '100px',
                                                        height: '60px',
                                                        borderRadius: '50%',
                                                    }}
                                                />


                                            </div>
                                            <div className="grid">
                                                <div className="col-2">
                                                    <div className="description-block">
                                                        {/* <h5 className="description-header">{response.name}</h5>
                                                <span className="description-text">Country</span> */}
                                                        <h5 className="description-header">{response.doctors}</h5>
                                                        <span className="description-text">Doctor</span>


                                                    </div>
                                                </div>
                                                <div className='col-1'></div>
                                                <div className="col-3">
                                                    <div className="description-block">
                                                        <h5 className="description-header">{response.assistants}</h5>
                                                        <span className="description-text">ASSISTANTS</span>
                                                    </div>
                                                </div>
                                                <div className='col-2'></div>
                                                <div className="col-3">
                                                    <div className="description-block">
                                                        <h5 className="description-header">{response.linkassistants}</h5>
                                                        <span className="description-text style={{ marginRight: '20px' }} ">LINK ASSISTANT</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </Card>

                                    </>
                                ))}
                            </div>
                            <div className='col-9'>
                                <Stepper ref={stepperRef}>



                                    <StepperPanel header="Supervisor Details">

                                        <Card>
                                            <Panel header="Hospital Name">
                                                <div className="grid">
                                                    {supervisor.map((response: any) => (

                                                        <>
                                                            <div className="col-12 md:col-12 lg:col-6">
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Hospital Name :</strong>
                                                                    <p className="text-muted">{response.hospitalname}</p>
                                                                </div>


                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Hospital Prefix :</strong>
                                                                    <p className="text-muted">{response.hospitalprefix}</p>
                                                                </div>

                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Email :</strong>
                                                                    <p className="text-muted">{response.email}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Phone No:</strong>
                                                                    <p className="text-muted">{response.phone}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Address :</strong>
                                                                    <p className="text-muted">{response.saddress}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>City :</strong>
                                                                    <p className="text-muted">{response.scity}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>State :</strong>
                                                                    <p className="text-muted">{response.statename}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Country :</strong>
                                                                    <p className="text-muted">{response.CountryName}</p>
                                                                </div>

                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Status :</strong>
                                                                    <p className="text-muted">{response.status}</p>
                                                                </div>



                                                            </div>
                                                            <div className="col-12 md:col-12 lg:col-6">
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Supervisor Name :</strong>
                                                                    <p className="text-muted">{response.sfname || response.slname}</p>
                                                                </div>

                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Email :</strong>
                                                                    <p className="text-muted">{response.email}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Address :</strong>
                                                                    <p className="text-muted">{response.saddress}</p>
                                                                </div>

                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Phone :</strong>
                                                                    <p className="text-muted">{response.sphone}</p>
                                                                </div>

                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>City :</strong>
                                                                    <p className="text-muted">{response.scity}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>State :</strong>
                                                                    <p className="text-muted">{response.statename}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Country :</strong>
                                                                    <p className="text-muted">{response.CountryName}</p>
                                                                </div>
                                                                <div className='grid' style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <strong style={{ marginRight: '10px' }}>Status :</strong>
                                                                    <p className="text-muted">{response.status}</p>
                                                                </div>


                                                                {/* </div> */}
                                                            </div>
                                                        </>
                                                    ))}
                                                </div>

                                            </Panel>

                                        </Card>
                                    </StepperPanel>
                                    <StepperPanel header="Doctors Details">

                                        <Card>
                                            <Panel header="">

                                                <div className="card card-primary">
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <DataTable value={datadoctor} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} filters={{ global: { value: globalFilter, matchMode: 'contains' } }}
                                                        globalFilterFields={['FirstName', 'SpecilityName', 'Email', 'Status']}>
                                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                        <Column field="FirstName" sortable header="Doctor Name"></Column>
                                                        <Column field="SpecilityName" sortable header=" Speciality"></Column>
                                                        <Column field="Email" sortable header="Email"></Column>

                                                    </DataTable>
                                                </div>
                                            </Panel>


                                        </Card>
                                    </StepperPanel>
                                    <StepperPanel header="Assistant Details">

                                        <Card>
                                            <Panel header="">

                                                <div className="card card-primary">
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <DataTable value={assistant} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                        <Column field="FirstName" sortable header="Assistant Name"></Column>
                                                        <Column field="Email" sortable header="Email"></Column>
                                                        <Column field="Phone" sortable header="Phone"></Column>

                                                    </DataTable>
                                                </div>
                                            </Panel>
                                        </Card>
                                    </StepperPanel>
                                    <StepperPanel header="Link Assistant Details">

                                        <Card>
                                            <Panel header="">

                                                <div className="card card-primary">
                                                    <div className="card flex flex-wrap justify-content">
                                                        <span className="p-input-icon-left">
                                                            <i className="pi pi-search" />
                                                            <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Global Search" />
                                                        </span>
                                                    </div>
                                                    <DataTable value={linkassistant} stripedRows paginator rows={5} rowsPerPageOptions={[5, 10, 25, 50]} tableStyle={{ minWidth: '50rem' }} globalFilter={globalFilter} >
                                                        <Column body={(rowData, { rowIndex }) => rowIndex + 1} header="S.No"></Column>
                                                        <Column field="dFirstName" sortable header="Doctor Name"></Column>
                                                        <Column field="FirstName" sortable header="Assistant Name"></Column>

                                                    </DataTable>
                                                </div>
                                            </Panel>


                                        </Card>
                                    </StepperPanel>



                                </Stepper>





                            </div>
                        </div>

                    </section>

                </div>
            </div>
            {/* <Dialog header="View" style={{ width: '50vw' }} visible={ViewDilog} onHide={() => setViewDilog(false)}>
        <div className="modal-header">
        </div>
        <div className="modal-body">
            {viewdata.map((response: any, index: number) =>
                <div key={index}>
                    <img src={response.displayfile} alt="Doc" width="100%" height="auto" />
                </div>
            )}
        </div>
    </Dialog> */}



        </div>
    )
}
